import { render } from "./InfosComponent.vue?vue&type=template&id=42ba9d11&scoped=true"
import script from "./InfosComponent.vue?vue&type=script&lang=js"
export * from "./InfosComponent.vue?vue&type=script&lang=js"

import "./InfosComponent.vue?vue&type=style&index=0&id=42ba9d11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42ba9d11"]])

export default __exports__